import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Login } from './pages/Login';
import { GeoportalsList } from './pages/GeoportalsList';
import { GeoportalEditor } from './pages/GeoportalEditor';
import { Viewer } from './pages/Viewer';
import { DataSources } from './pages/DataSources';
import { Users } from './pages/Users';
import './index.css';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/"        element={<GeoportalsList />} />
        <Route path="/login"   element={<Login />} />
        <Route path="/g/:id"   element={<GeoportalEditor />} />
        <Route path="/v/:slug" element={<Viewer />} />
        <Route path="/sources" element={<DataSources />} />
        <Route path="/users"   element={<Users />} />
      </Routes>
    </BrowserRouter>
  </StrictMode>
);
